var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 0.957733H1.70893C0.766071 0.957733 0 1.73452 0 2.68809V23.2274C0 24.1809 0.766071 24.9577 1.70893 24.9577H22.2857C23.2286 24.9577 24 24.1809 24 23.2274V2.68809C24 1.73452 23.2286 0.957733 22.2857 0.957733ZM7.25357 21.5292H3.69643V10.0756H7.25893V21.5292H7.25357ZM5.475 8.5113C4.33393 8.5113 3.4125 7.58452 3.4125 6.4488C3.4125 5.31309 4.33393 4.3863 5.475 4.3863C6.61071 4.3863 7.5375 5.31309 7.5375 6.4488C7.5375 7.58988 6.61607 8.5113 5.475 8.5113ZM20.5875 21.5292H17.0304V15.9577C17.0304 14.6292 17.0036 12.9202 15.1821 12.9202C13.3286 12.9202 13.0446 14.3667 13.0446 15.8613V21.5292H9.4875V10.0756H12.9V11.6399H12.9482C13.425 10.7399 14.5875 9.79166 16.3179 9.79166C19.9179 9.79166 20.5875 12.1649 20.5875 15.2506V21.5292Z",
    fill: "#6369C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.bc8e6d1d312342bf032f08cc7b183091.svg";
export { ForwardRef as ReactComponent };